import { getConfig } from '../config.js';

/**
 * Resolves some cases with special syntax when using import-map entries
 * Folder entries which are missing a file ending will add a DEFAULT_SUFFIX file ending
 * Imports containing module#subModule syntax will resolve to submodule:resolvedUrl#subModule
 * Imports containing one more slash from a non-folder entry e.g. @qmfe/module/submodule
 * where "@qmfe/module" resolves to a url will resolve to submodule:resolvedUrl#submodule
 * @param {string} id - import map entry
 * @param {Object} imports - import map values
 * @param {Function} getMatch - function for getting a match from imports with an id
 * @returns - resolved string or undefined
 */
export function submoduleResolve(id, imports, getMatch) {
  if (!id) return
  // check for module#subModule syntax
  var submodule
  [id, submodule] = id.split('#');

  var match = getMatch(id, imports);
  var submoduleAppend = '';
  while (!match) {
    // check for matches by removing slashes backwards until there's no slash left
    var slashix = id.lastIndexOf('/');
    if (slashix >= 0) {
      var modId = id.substring(0, slashix);
      match = getMatch(modId, imports);
      if (match) {
        submodule = id.substring(slashix + 1) + submoduleAppend;
      } else {
        submoduleAppend = id.substring(slashix) + submoduleAppend;
      }
      id = modId;
    } else {
      // no slash found
      break;
    }
  }
  if (match) {
    var suffix = "";
    var mapped = imports[match];
    mapped = mapped && mapped + id.slice(match.length);
    const config = getConfig();
    if (config.DEFAULT_RESOLVE && mapped && match[match.length-1] === '/') {
      // is folder match
      var afterLastSlash = mapped.substring(mapped.lastIndexOf("/") + 1);
      if (afterLastSlash && afterLastSlash.match(/^.*\.[0-9a-z]+$/) === null) {
        suffix = config.DEFAULT_RESOLVE;
      }
    }
    var resolved = mapped + suffix;
    if (resolved && submodule) {
      resolved = "submodule:" + resolved + "#" + submodule;
    }
    return resolved
  }
}